// src/utils/fetchStudentDocs.js
import { doc, getDoc, collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase";

export async function fetchStudentDocs(uid) {
  const [primarySnap, siblingsSnap] = await Promise.all([
    getDoc(doc(db, "students", uid)),
    getDocs(query(collection(db, "students"), where("uid", "==", uid))),
  ]);
  const docs = [];
  if (primarySnap.exists()) docs.push({ id: uid, ...primarySnap.data() });
  siblingsSnap.forEach(snap => {
    if (snap.id !== uid) docs.push({ id: snap.id, ...snap.data() });
  });
  return docs;
}
